import arrowLeftBlue from '../../assets/images/icons/footer/backbutton.png';
import playIcon from '../../assets/images/icons/footer/play.png';
import scenarioIcon from '../../assets/images/icons/footer/scenario.png';
import wifiNormalIcon from "../../assets/images/icons/footer/indicator-wifi.png"
import wifiErrorIcon from "../../assets/images/icons/footer/indicator-wifi-error.png"
import wifiActiveIcon from "../../assets/images/icons/footer/indicator-wifi-active.png"
import wifiWarningIcon from "../../assets/images/icons/footer/indicator-wifi-warning.png"
import ethernetNormalIcon from "../../assets/images/icons/footer/indicator-ethernet.png"
import ethernetErrorIcon from "../../assets/images/icons/footer/indicator-ethernet-error.png"
import ethernetActiveIcon from "../../assets/images/icons/footer/indicator-ethernet-active.png"
import ethernetWarningIcon from "../../assets/images/icons/footer/indicator-ethernet-warning.png"
import sipNormalIcon from "../../assets/images/icons/footer/calling.png"
import sipErrorIcon from "../../assets/images/icons/footer/calling-error.png"
import sipActiveIcon from "../../assets/images/icons/footer/calling-active.png"
import sipWarningIcon from "../../assets/images/icons/footer/calling-warning.png"
import groupOpen from '../../assets/images/icons/footer/group-open.png';
import groupClose from '../../assets/images/icons/footer/group-close.png';
import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {ConnectionIcons, ScenarioModel} from '../../store/control/state';
import {onClickHandler} from '../../utils/onclick';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import {useQuestion} from '../../hooks/question';
import {clearUserAction} from '../../store/user/action';
import {removeSession} from '../../utils/session-storage';
import {useRPC} from '../../hooks/rpc';
import {useLocalization} from "../../hooks/localization";
import { useChangeTheme } from '../../hooks/change-theme';

type Props = {
    locked: boolean;
    scenarioModelList: ScenarioModel[];
    onScenarioClick: (scenario: ScenarioModel) => void;
};
const explode = () => {
    throw new Error('kaboom');
};

export const FooterComponent = memo(function FooterComponent(props: Props) {
    const {t} = useLocalization();
    const history = useHistory();
    const question = useQuestion();
    const [rpc] = useRPC();
    const dispatch = useDispatch();
    const userList = useSelector(state => state.control.userList);
    const groupSetting = useSelector(state => state.ui.groupSetting);
    const username = useSelector(state => state.user.username);
    const currentUser = useMemo(() => userList.find((u) => u.username === username), [userList, username]);
    const {locked, scenarioModelList, onScenarioClick} = props;
    const backButton = useSelector(state => state.ui.backButton);
    const messageNotificationList = useSelector(state => state.control.messageNotification)
    const location = useLocation();
    const connectionIconSelector = useSelector(state => state.control.connectionIcons)
    const [connectionStatus, setConnectionStatus] = useState<ConnectionIcons>(connectionIconSelector)
    const {theme} = useChangeTheme();

    const onEditPress = useCallback(() => {
        history.push('/settings/users/edit/' + currentUser.id);
    }, [currentUser, history]);

    const onLoginPress = useCallback(() => {
        history.push('/settings/login');
    }, [history]);

    const onLogoutPress = useCallback(() => {
        question(t('DO_YOU_WANT_TO_LOG_OUT'), () => {
            rpc.doLogout();
            dispatch(clearUserAction());
            removeSession();
            history.push('/login');
            window.location.reload();
        });
    }, [t, dispatch, question, rpc, history]);


    const onGroupToggle = (status) => {
        rpc.groupScriptCommand(location.pathname.split("/")[2], status)
    }

    useEffect(() => {
        //if (username === 'default') {
            const interval = setInterval(() => {
                rpc.GetConnIcons().then(data => setConnectionStatus(data))
            }, 5000)
            return () => clearInterval(interval)
        //}
    }, [rpc, connectionStatus])

    const wifiIcon: string = useMemo(() => {
        switch (connectionStatus?.wifi_level) {
            case "green":
                return wifiActiveIcon
            case "red":
                return wifiErrorIcon
            case "yellow":
                return wifiWarningIcon
            default:
                return wifiNormalIcon
        }
    }, [connectionStatus])

    const ethernetiIcon: string = useMemo(() => {
        switch (connectionStatus?.ethernet) {
            case "green":
                return ethernetActiveIcon
            case "red":
                return ethernetErrorIcon
            case "yellow":
                return ethernetWarningIcon
            default:
                return ethernetNormalIcon
        }
    }, [connectionStatus])

    const sipIcon: string = useMemo(() => {
        switch (connectionStatus?.sip) {
            case "green":
                return sipActiveIcon
            case "red":
                return sipErrorIcon
            case "yellow":
                return sipWarningIcon
            default:
                return sipNormalIcon
        }
    }, [connectionStatus])

    // @ts-ignore
    return (
        <div className={'footer' + (locked ? ' blur' : '')}>
            <div className='row'>
                <NavLink className={`button footer-bg radius-top-right float-left back-button`} style={{
                    borderTopRightRadius: theme === 'rounded' ? '15px' : '0'
                }}
                         to={backButton.to}>
                    <img src={arrowLeftBlue} alt='' style={{width: '20px', height: '33px'}} />
                </NavLink>

                <div className={`footer-bg radius-top-left`} style={{
                    borderTopLeftRadius: theme === 'rounded' ? '15px' : '0'
                }}>
                {
                    renderIf((username === 'default') && (location.pathname.split("/")[1] !== 'area'))(() =>
                        scenarioModelList.map(scenarioModel => {
                            return (
                                <span
                                    key={`scenario_${scenarioModel.id}`}
                                    className="button float-left scenario-button hidden-scenario"
                                    {...onClickHandler(() => onScenarioClick(scenarioModel))}>
                                <img src={scenarioModel.is_playing ? playIcon : (scenarioModel?.icon_type || scenarioIcon)} alt=''/>
                                <span>{scenarioModel.name}</span>
                            </span>
                            );
                        })
                    )
                }

                {
                    groupSetting.visible && location.pathname.split("/")[1] === 'area' && <div className="group-buttons">
                     <span className="button"
                           {...onClickHandler(() => onGroupToggle(true))}>
                                <img src={groupOpen} alt=''/>
                                <span>{t('group_on')}</span>
                     </span>
                        <span className="button"
                              {...onClickHandler(() => onGroupToggle(false))}>
                                <img src={groupClose} alt=''/>
                                <span>{t('group_off')}</span>
                    </span>
                    </div>
                }

                <div className='user-info float-right'>
                    {
                        renderIf(username !== 'default')(() =>
                            <>
                                {
                                    renderIf(messageNotificationList?.unread)(()=> (
                                        <div className='footer-message-icon' {...onClickHandler(()=>history.push('/messaging'))}>
                                            <span>{messageNotificationList?.unread || 0}</span>
                                        </div>
                                    ))
                                }
                                {renderIf(location.pathname === '/settings')(() => (
                                    <>
                                        <div onClick={onEditPress}>
                                            <span className="user-text">{username}</span>
                                        </div>
                                        <div className="logout-button" onClick={onLogoutPress}>
                                            <span className="user-text color-red">{t("LOG_OUT")}</span>
                                        </div>
                                    </>
                                ))}
                            </>,
                        )
                    }
                    {
                        renderIf(username === 'default' && (history.location.pathname === '/settings' || history.location.pathname === '/developer'))(() =>
                            <div onClick={onLoginPress}>
                                <span className='user-text'>{t('LOGIN')}</span>
                            </div>,
                        )
                    }
                </div>
                {
                    renderIf(!(history.location.pathname === '/settings' || history.location.pathname === '/developer'))(() =>
                        <div className={`small-icons float-right `} //${username !== 'default' ? 'invisible' : ''}
                             onClick={explode}>
                            <img src={wifiIcon} alt=''/>
                            <img src={ethernetiIcon} alt=''/>
                            <img src={sipIcon} alt=''/>
                        </div>,
                    )
                }
                </div>
            </div>
        </div>
    );
});
